import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import About from "../pages/about/page";
import Features from "../pages/features/page";
import Pricing from "../pages/pricing/page";
import Integrations from "../pages/integrations/page";
import Contact from "../pages/contact/page";
import Login from "../pages/auth/login/page";
import Signup from "../pages/auth/signup/page";
import ForgotPassword from "../pages/auth/forgot-password/page";
import FAQ from "../pages/faq/page";
import Playground from "../pages/playground/page";
import Affiliates from "../pages/affiliates/page";
import Careers from "../pages/careers/page";
import Press from "../pages/press/page";
import Security from "../pages/security/page";
import Compare from "../pages/compare/page";
import SubscriptionTerms from "../pages/subscription-terms/page";
import TermsOfUse from "../pages/terms-of-use/page";
import TermsOfService from "../pages/terms-of-service/page";
import PrivacyPolicy from "../pages/privacy-policy/page";
import CookiePolicy from "../pages/cookie-policy/page";
import Tools from "../pages/tools/page";
import CaptionGenerator from "../pages/tools/caption-generator/page";
import HashtagGenerator from "../pages/tools/hashtag-generator/page";
import ROICalculator from "../pages/tools/roi-calculator/page";
import CaseStudies from "../pages/case-studies/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/features",
    element: <Features />,
  },
  {
    path: "/pricing",
    element: <Pricing />,
  },
  {
    path: "/integrations",
    element: <Integrations />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/signup",
    element: <Signup />,
  },
  {
    path: "/forgot-password",
    element: <ForgotPassword />,
  },
  {
    path: "/faq",
    element: <FAQ />,
  },
  {
    path: "/playground",
    element: <Playground />,
  },
  {
    path: "/affiliates",
    element: <Affiliates />,
  },
  {
    path: "/careers",
    element: <Careers />,
  },
  {
    path: "/press",
    element: <Press />,
  },
  {
    path: "/security",
    element: <Security />,
  },
  {
    path: "/compare",
    element: <Compare />,
  },
  {
    path: "/subscription-terms",
    element: <SubscriptionTerms />,
  },
  {
    path: "/terms-of-use",
    element: <TermsOfUse />,
  },
  {
    path: "/terms-of-service",
    element: <TermsOfService />,
  },
  {
    path: "/privacy-policy",
    element: <PrivacyPolicy />,
  },
  {
    path: "/cookie-policy",
    element: <CookiePolicy />,
  },
  {
    path: "/tools",
    element: <Tools />,
  },
  {
    path: "/tools/caption-generator",
    element: <CaptionGenerator />,
  },
  {
    path: "/tools/hashtag-generator",
    element: <HashtagGenerator />,
  },
  {
    path: "/tools/roi-calculator",
    element: <ROICalculator />,
  },
  {
    path: "/case-studies",
    element: <CaseStudies />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
